<template>
  <div>
    <div style="position:absolute; top: 30px; left: 30px; background-color: white; width: auto; border-radius: 12px;">
      <i
        class="fa-solid fa-angle-left px-3 py-2 text-center"
        style="color:#011638"
      />
    </div>
    <p>{{ env }}</p>
    <div
      class="row m-0 p-0"
      style="background-color: #F5F6F8; height: 100vh;"
    >
      <div class="col-xl-3 col-lg-4 col-md-5 col-12 p-0 div-image">
        <img
          class="login-image"
          src="../../src/assets/loginIMG.jpeg"
        >
      </div>
      <login-component class="d-md-flex align-items-center justify-content-center col-xl-9 col-lg-8 col-md-7 col-12 login-div"></login-component>
    </div>
  </div>

  
</template>

<script>
import LoginComponent from '../components/LoginComponent.vue';
import * as Sentry from '@sentry/vue';

  export default {
    name: 'LoginPage',
    components:{
      LoginComponent
    },
    data: function() {
      return {
        env: process.env.VUE_APP_ENV
      }
    },
    mounted(){
      try {
        throw new Error("Algo salió mal");
      } catch (e) {
        Sentry.captureException(e);
      }
    }
}

</script>

<style scoped>

  .login-image{
    width: 100%;
    height: 100%;
    object-fit:cover;
  }

  .login-div{
    padding: 0px 250px 0px 250px;
  }

  .form-floating > label{
    color: #8E97A7 !important
  }

  .form-control{
    border: 0px;
    border-radius: 12px;
  }

  .modal {
    background: rgba(139, 139, 139, 0.5);
  }
  .modal-dialog {
    min-height: 90vh;
  }

  @media screen and (max-width: 1700px) {
    .login-div{
      padding: 0px 220px 0px 220px;
    }
  }

  @media screen and (max-width: 1500px) {
    .login-div{
      padding: 0px 180px 0px 180px;
    }
  }

  @media screen and (max-width: 1350px) {
    .login-div{
      padding: 0px 150px 0px 150px;
    }
  }

  @media screen and (max-width: 1200px) {
    .login-div{
      padding: 0px 100px 0px 100px;
    }
  }

  @media screen and (max-width: 768px) {
    .login-image{
      border-radius: 0 0 25px 25px;
    }
    .div-image{
      max-height: 225px;
    }
    .login-div{
      min-height: calc(100vh - 225px);
    }
  }

  @media screen and (max-width: 576px) {
    .login-div{
      padding: 0px 50px 0px 50px;
    }
  }

  @media screen and (max-width: 500px) {
    .login-div{
      padding: 0px 20px 0px 20px;
    }
  }
</style>